import { motion } from "motion/react";
import PlayerType from "../../models/player";
import BackCard from "../BackCard";
import styles from "./OtherPlayer.module.css";

interface Props {
  player: PlayerType;
}

export default function OtherPlayer({ player }: Props) {
  const cards = player.hand.length;
  const active = player.turnToPlay ? styles.active : "";
  const centerShift =
    player.hand.length < 2 ? 0 : Math.round((player.hand.length - 1) * -2.5);

  return (
    <div className={`${styles.otherPlayer} ${active}`}>
      <div className={styles.hand} style={{ left: `${centerShift}px` }}>
        {player.hand.map((card, i) => (
          <motion.div
            layoutId={card.id}
            key={card.id}
            style={{ left: i * 5 + "px" }}
          >
            <BackCard />
          </motion.div>
        ))}
      </div>
      <div className={styles.info}>
        {player.name} ( {cards} )
      </div>
    </div>
  );
}
